import ApiManagerBase from "./api-manager-base";

const ApiManager = new ApiManagerBase();

export default ApiManager;
